import React__default from 'react';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { u as useChannelContext } from '../../chunks/bundle-e3Ti36sK.js';
import PlaceHolder, { PlaceHolderTypes } from '../../ui/PlaceHolder.js';
import ConnectionStatus from '../../ui/ConnectionStatus.js';
import ChannelHeader from './ChannelHeader.js';
import { M as MessageList, T as TypingIndicatorType } from '../../chunks/bundle-JP-jgzbg.js';
import TypingIndicator from './TypingIndicator.js';
import MessageInputWrapper from './MessageInput.js';
import '../../withSendbird.js';
import '../../chunks/bundle-FpyOg33P.js';
import '../../chunks/bundle-_iM6nCNy.js';
import '../../chunks/bundle-MbdTAPd0.js';
import '../../chunks/bundle-FKPPxTH5.js';
import '../../chunks/bundle-beh08z4N.js';
import '../../chunks/bundle-oJDE4gxT.js';
import '../../chunks/bundle-HBHAJNcI.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-nfdZFsK-.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-Qobh-hS4.js';
import '../../chunks/bundle-tIZkKr0f.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle--bKgEN9C.js';
import '../hooks/useInitialMessagesFetch.js';
import '../../chunks/bundle-PjrYdsK-.js';
import '../../chunks/bundle-wxDl4Uqr.js';
import '../../chunks/bundle-BQL-EsqQ.js';
import '../../chunks/bundle-KYdFoSY3.js';
import '../../chunks/bundle-qXzcabru.js';
import '../../chunks/bundle-Qz8Xvs0V.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-ZdB7DVTk.js';
import '../../chunks/bundle-afcKlUXe.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-7R8HEAQg.js';
import '../../ui/IconButton.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-c_C-QxZX.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-M5pt2U9r.js';
import '../../chunks/bundle-MwrVjf8I.js';
import '../../chunks/bundle-PS5DHcTM.js';
import './Message.js';
import './SuggestedMentionList.js';
import '../../chunks/bundle-qvWKHgxb.js';
import '../../Thread/context.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
import '../../ui/DateSeparator.js';
import '../../chunks/bundle-o5Vs-nxR.js';
import '../../ui/MessageInput.js';
import '../../ui/Button.js';
import '../../chunks/bundle-Os1fWxhI.js';
import 'dompurify';
import '../../chunks/bundle-1g6DWJD0.js';
import '../../chunks/bundle-_ZNty2ba.js';
import '../../chunks/bundle-oo5v2vDN.js';
import '../../chunks/bundle-Ey_7-wSi.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-TEnd9cUe.js';
import '../../chunks/bundle-bt0zGtez.js';
import '../../chunks/bundle-DxDwP2lI.js';
import '../../ui/MessageItemMenu.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-un0fMvD_.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-RsvOCwtb.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-tZpfBaVT.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-mNQe1dzf.js';
import '../../chunks/bundle-PFX2Yr9t.js';
import '../../ui/ThreadReplies.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-VRFfBFLq.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-vRivVL8u.js';
import '../../chunks/bundle-mHHG9KoF.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-TcioQEN5.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import './FileViewer.js';
import './RemoveMessageModal.js';
import '../../chunks/bundle-DzuA_apO.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../utils/getMessagePartsInfo.js';
import '../utils/compareMessagesForGrouping.js';
import './UnreadCount.js';
import './FrozenNotification.js';
import '../../chunks/bundle-qfjnmlHx.js';
import '@sendbird/uikit-tools';
import '../../ui/TypingIndicatorBubble.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-ynu0QV4r.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-78frOEM6.js';
import '../hooks/useHandleUploadFiles.js';
import '../../chunks/bundle-GPxxY-H1.js';

var ChannelUI = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var isLoading = _a.isLoading, renderPlaceholderLoader = _a.renderPlaceholderLoader, renderPlaceholderInvalid = _a.renderPlaceholderInvalid, renderPlaceholderEmpty = _a.renderPlaceholderEmpty, renderChannelHeader = _a.renderChannelHeader, renderMessage = _a.renderMessage, renderMessageInput = _a.renderMessageInput, renderTypingIndicator = _a.renderTypingIndicator, renderCustomSeparator = _a.renderCustomSeparator, renderFileUploadIcon = _a.renderFileUploadIcon, renderVoiceMessageIcon = _a.renderVoiceMessageIcon, renderSendMessageIcon = _a.renderSendMessageIcon, renderFrozenNotification = _a.renderFrozenNotification;
    var _l = useChannelContext(), channelUrl = _l.channelUrl, isInvalid = _l.isInvalid;
    var globalStore = useSendbirdStateContext();
    var sdkError = (_c = (_b = globalStore === null || globalStore === void 0 ? void 0 : globalStore.stores) === null || _b === void 0 ? void 0 : _b.sdkStore) === null || _c === void 0 ? void 0 : _c.error;
    var logger = (_d = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _d === void 0 ? void 0 : _d.logger;
    var isOnline = (_e = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _e === void 0 ? void 0 : _e.isOnline;
    if (isLoading) {
        return (React__default.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderLoader === null || renderPlaceholderLoader === void 0 ? void 0 : renderPlaceholderLoader()) || (React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING }))));
    }
    if (!channelUrl) {
        return (React__default.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || (React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.NO_CHANNELS }))));
    }
    if (isInvalid) {
        return (React__default.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || (React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG }))));
    }
    if (sdkError) {
        return (React__default.createElement("div", { className: "sendbird-conversation" }, (renderPlaceholderInvalid === null || renderPlaceholderInvalid === void 0 ? void 0 : renderPlaceholderInvalid()) || (React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG, retryToConnect: function () {
                logger.info('Channel: reconnecting');
                // reconnect();
            } }))));
    }
    return (React__default.createElement("div", { className: 'sendbird-conversation' },
        (renderChannelHeader === null || renderChannelHeader === void 0 ? void 0 : renderChannelHeader()) || (React__default.createElement(ChannelHeader, { className: "sendbird-conversation__channel-header" })),
        React__default.createElement(MessageList, { className: "sendbird-conversation__message-list", renderMessage: renderMessage, renderPlaceholderEmpty: renderPlaceholderEmpty, renderCustomSeparator: renderCustomSeparator, renderPlaceholderLoader: renderPlaceholderLoader, renderFrozenNotification: renderFrozenNotification }),
        React__default.createElement("div", { className: "sendbird-conversation__footer" },
            (renderMessageInput === null || renderMessageInput === void 0 ? void 0 : renderMessageInput()) || (React__default.createElement(MessageInputWrapper, { renderFileUploadIcon: renderFileUploadIcon, renderVoiceMessageIcon: renderVoiceMessageIcon, renderSendMessageIcon: renderSendMessageIcon })),
            React__default.createElement("div", { className: "sendbird-conversation__footer__typing-indicator" },
                (renderTypingIndicator === null || renderTypingIndicator === void 0 ? void 0 : renderTypingIndicator())
                    || (((_g = (_f = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _f === void 0 ? void 0 : _f.groupChannel) === null || _g === void 0 ? void 0 : _g.enableTypingIndicator)
                        && ((_k = (_j = (_h = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config) === null || _h === void 0 ? void 0 : _h.groupChannel) === null || _j === void 0 ? void 0 : _j.typingIndicatorTypes) === null || _k === void 0 ? void 0 : _k.has(TypingIndicatorType.Text))
                        && (React__default.createElement(TypingIndicator, null))),
                !isOnline && (React__default.createElement(ConnectionStatus, null))))));
};

export { ChannelUI as default };
//# sourceMappingURL=ChannelUI.js.map
